import React from "react";
import StatesDropDown from "../components/StatesDropDown";
import { Row, Col } from 'react-bootstrap';
import SATextInput from "./SATextInput";

const Address=(props)=> {
    const register = props.register;
    const errors = props.errors; 
    return (
        <React.Fragment>
            <Row>
                <Col lg={8}>
                    <SATextInput
                        register={register}
                        htmlFor={props.htmlForAddress1}
                        name={props.address1Name}
                        label={"Street Address:"}
                        isStrong={true}
                        type={"text"}
                        placeholder={"Street Address (required)"}
                        errors={errors}
                        id={props.addressId}
                        errMsg={props?.errMsg}
                        maxLength={250}
                        requiredObj={{ required: "Street Address is required!",
                        pattern: {
                            value: /[\sa-zA-Z0-9.s',#/@ -/&]+$/, message: "Invalid Street Address1!"
                        }
                     }}
                        

                    />
                </Col>
                <Col lg={4}>
                    <SATextInput
                        register={register}
                        htmlFor={props.htmlForAddress2}
                        name={props.address2Name}
                        label={"Address 2:"}
                        isStrong={false}
                        type={"text"}
                        placeholder={"Address 2"}
                        maxLength={100}
                        errors={errors}
                    />
                </Col>

                <Col lg={6}>
                    <SATextInput
                        register={register}
                        htmlFor={props.htmlForCity}
                        name={props.cityName}
                        label={"City:"}
                        isStrong={true}
                        type={"text"}
                        placeholder={"City (required)"}
                        errors={errors}
                        id={props.cityId}
                        errMsg={props.cityErrMsg}
                        maxLength={32}
                        requiredObj={{ required: "City is required!",
                        pattern: {
                            value: /(^[a-zA-Z-.'\s]*$)/, message: "Invalid City!"
                        }
                    }}
                        
                    />
                </Col>
                <Col lg={3}>
                    <StatesDropDown
                        label={"State:"}
                        register={register}
                        errors={errors}
                        htmlFor={props.htmlForState}
                        name={props.stateName}
                        id={props.stateHelp}
                        errMsg={props.stateErrMsg}
                        requiredObj={{ required: "State is required!" }}
                        
                    />
                </Col>

                <Col lg={3}>
                    <SATextInput
                        register={register}
                        htmlFor={props.htmlForZipCode}
                        name={props.zipCodeName}
                        label={"ZIP Code:"}
                        isStrong={true}
                        type={"text"}
                        placeholder={"ZIP Code"}
                        errors={errors}
                        id={props.zipcodeId}
                        errMsg={props.zipCodeErrMsg}
                        
                        requiredObj={{ required: "ZIP Code is required!", 
                        pattern: { value: /^[0-9]{5}$/, message: "Invalid ZIP Code!" } }}
                        maxLength={"5"}
                       
                    />
                </Col>
            </Row>
        </React.Fragment>
    );
}

export default  Address;